"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./create-cdn-endpoint/create-cdn-endpoint"), exports);
__exportStar(require("./delete-cdn-endpoint/delete-cdn-endpoint"), exports);
__exportStar(require("./get-cdn-endpoint/get-cdn-endpoint"), exports);
__exportStar(require("./list-cdn-endpoints/list-cdn-endpoints"), exports);
__exportStar(require("./purge-cache/purge-cache"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./update-cdn-endpoint/update-cdn-endpoint"), exports);
//# sourceMappingURL=index.js.map